module.exports = __webpack_public_path__ + "static/media/story-modal-bg-web.ac4bcb22.png";